import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'insight-graphic',
  templateUrl: './insight-graphic.component.html',
  styleUrls: ['./insight-graphic.component.css']
})
export class InsightGraphicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/insight-graphic/insight-graphic.component.ts